import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { FrameworkService } from '@gsp-sys/rtf-common';
import { ViewModel } from '@farris/devkit';
import { Injectable, Optional } from '@angular/core';
import { ParamService } from './param.service';
import { RuntimeFrameworkService } from './rtf-service';
import { BefRepository } from '@farris/bef';
import { isObservable } from 'rxjs';

/**
 * åºç¨åæ°æå¡
 * @scope FormModule
 */

@Injectable()
export class ApplicationParamService {
  private params: any;
  constructor(
    @Optional() private paramService: ParamService,
    @Optional() private runtimeFrameworkService: RuntimeFrameworkService,
  ) {
    if (!this.runtimeFrameworkService) {
      this.runtimeFrameworkService = new RuntimeFrameworkService();
    }
  }
  /**
   * è§£æåæ°
   */
  public parseParams(route: ActivatedRoute, frameworkService: FrameworkService, viewModel: ViewModel, callback: () => void) {
    const highOrderInvoke = this.highOrderInvoke(callback);
    if (!this.paramService) {
      route.queryParams.pipe(take(1)).subscribe((params: any) => {
        this.params = params;
        this.setupParams(params, frameworkService, viewModel, highOrderInvoke);
      });
    } else {
      this.paramService.parse().pipe(take(1)).subscribe((params) => {
        this.params = params;
        this.setupParams(params, frameworkService, viewModel, highOrderInvoke);
      });
    }
  }

  /**
   * è®¾ç½®åæ°
   */
  private setupParams(params, frameworkService: FrameworkService, viewModel: ViewModel, callback: () => void) {
    if (viewModel && viewModel.frameContext && viewModel.frameContext.appContext && params.tabId) {
      viewModel.frameContext.appContext.tabId = params.tabId;
    }
    const queryParams = this.getParams(params);
    if (!queryParams) {
      callback();
      return;
    }

    // åè®¾ç½®åæ°ï¼ä¿è¯æ®éè·¯ç±ä¹è½æ­£å¸¸æ§è¡ã
    this.setQueryParams(queryParams, viewModel);

    const funcId = this.getFuncId(queryParams);
    const appId = this.getAppId(queryParams);
    if (!funcId && !appId) {
      callback();
      return;
    }

    if (funcId) {
      this.setStaticParams(funcId, queryParams, frameworkService, viewModel, callback);
    } else {
      callback();
    }
  }
  /**
   * è®¾ç½®æ¥è¯¢åæ°
   */
  private setQueryParams(queryParams: any, viewModel: ViewModel): any {
    const parsedQueryParams = {};
    // è®¾ç½®è¡¨ååæ°
    // é¦åå¤æ­æ¯å¦ä¸ºå¼¹çª
    const isInDialog = this.isInDialog(viewModel);
    const uiState = viewModel && viewModel.uiState && viewModel.uiState.innerData || {};
    // å¦ææ¯å¼¹çªï¼å¼¹çªå¤çåæ°ï¼æ è®ºè¡¨ååæ°æéæåæ°ï¼ä¸åºè¯¥è¦çå¼¹çªçåæ°ãå¼¹çªæå¼æ¶ä¼ éçåæ°ç¸å½äºå±é¨åéï¼ä¸åºè¢«è¦ç
    Object.keys(queryParams).forEach((paramName: string) => {
      if (!isInDialog) {
        parsedQueryParams[paramName] = queryParams[paramName];
      } else {
        if (!uiState.hasOwnProperty(paramName)) {
          parsedQueryParams[paramName] = queryParams[paramName];
        }
      }
    });
    this.updateUIState(viewModel, parsedQueryParams);
  }

  /**
   * è®¾ç½®éæåæ°
   */
  private setStaticParams(
    funcId: string, queryParams: any, frameworkService: FrameworkService, viewModel: ViewModel, callback: () => void
  ) {
    this.runtimeFrameworkService.getMenuParams(funcId, (staicParams) => {
      const staticParamsObj = this.mapStaticParamsToObject(staicParams, queryParams, viewModel);
      if (!staticParamsObj) {
        callback();
        return;
      }
      this.updateUIState(viewModel, staticParamsObj);
      callback();
    });
  }

  /**
   * å°staticParamsè½¬æ¢ä¸ºæ®éå¯¹è±¡
   * @param staticParamsï¼å½¢å¦ï¼[{'name': 'key1', 'value': 'val1'}, {'name': 'key2', 'value': 'val2'}]
   * @return å½¢å¦ï¼{key1: val1, key2: value2 }
   */
  private mapStaticParamsToObject(staticParams: Map<any, any>, queryParams: any, viewModel?: ViewModel): any {
    if (!staticParams) {
      return;
    }
    const inDialog = this.isInDialog(viewModel);
    const uiState = viewModel && viewModel.uiState && viewModel.uiState.innerData || {};
    const result = {};
    staticParams.forEach((value, key, map) => {
      if (!inDialog) {
        // éæåæ°ä¸è½è¦çæ¥è¯¢åæ°
        if (!queryParams.hasOwnProperty(key)) {
          result[key] = value;
        }
      } else {
        if (!queryParams.hasOwnProperty(key) && !uiState.hasOwnProperty(key)) {
          result[key] = value;
        }
      }
    });
    return result;
  }
  /**
   * æ¯å¦å¨å¼¹çªå
   * @param viewModel viewmodel
   */
  private isInDialog(viewModel: ViewModel) {
    let isInDialog = false;
    if (viewModel && viewModel.uiState) {
      // tslint:disable-next-line: max-line-length
      if (viewModel.uiState.innerData && viewModel.uiState.innerData.hasOwnProperty('DEVKIT_DIALOG') || viewModel.uiState['DEVKIT_DIALOG']) {
        isInDialog = true;
      }
    }
    return isInDialog;
  }
  /**
   * æ´æ°UIState
   */
  private updateUIState(viewModel: ViewModel, params: any) {
    if (!viewModel || !params) {
      return;
    }
    const uiState = viewModel.uiState;

    // å¼å®¹ä½¿ç¨stringä¼ éparamså¯¹è±¡çåºæ¯
    if (typeof params === 'string' && params !== '') {
      params = JSON.parse(params);
    }

    // å¨UIStateä¸ºåæ°åå»ºå±æ§
    Object.keys(params).forEach((propName: string) => {
      uiState.setPropertyValue(propName, params[propName]);
      // ç¹æ®å¤çï¼formConfigIdå¤ªéç¨ï¼ä¸ç¨æ·èªå®ä¹çè¡¨ååéå²çªå¯è½æ§è¾å¤§ï¼å æ­¤VOåéä¿®æ¹ä¸ºbffSysFormConfigId
      if (propName === 'formConfigId' && !viewModel.frameContext.namespace && viewModel.frameContext.appContext.useIsoluteEventBus === false) {
        uiState.setPropertyValue('bffSysFormConfigId', params[propName]);
      }
      if (propName && propName === 'union_session') {
        const sessionInfo = params[propName];
        this.setSessionInfo(viewModel, sessionInfo);
      }
    });
  }
  private setSessionInfo(viewModel: ViewModel, sessionInfo: any) {
    if (!viewModel || !sessionInfo) {
      return;
    }
    if (sessionInfo && typeof sessionInfo === 'string' && sessionInfo.startsWith('{') && sessionInfo.endsWith('}')) {
      sessionInfo = JSON.parse(sessionInfo);
    }
    const token = sessionInfo && sessionInfo.token || null;
    const sessionId = sessionInfo && sessionInfo.sessionId || null;
    if (token) {
      viewModel.frameContext.appContext.Token = token;
    }
    if (sessionId) {
      const befRepository = viewModel.frameContext.repository as BefRepository<any>;
      if (befRepository) {
        const runtimeContext = { tabId: this.runtimeFrameworkService.tabId };
        befRepository.restService.sessionService.setBeSessionId(sessionId, runtimeContext);
      }
    }
  }
  /**
   * è·ååè½èåid
   */
  private getFuncId(queryParams: any): any {
    if (!queryParams) {
      return;
    }
    return queryParams['funcId'];
  }

  /**
   * è·ååºç¨id
   */
  private getAppId(queryParams: any): any {
    if (!queryParams) {
      return;
    }
    return queryParams['appId'];
  }
  private getTabId(queryParams: any) {
    if (!queryParams) {
      return;
    }
    return queryParams['tabId'];
  }
  /**
   * è·åurlåæ°å¯¹è±¡
   * @param queryParams urlåæ°
   */
  private getParams(queryParams: any): { [propName: string]: any; } {
    if (!queryParams) {
      return {};
    }
    let result = {};
    if (queryParams.hasOwnProperty('WEB_FORM_ROUTE_PARAMS')) {
      let webFormRouteParams: string = queryParams['WEB_FORM_ROUTE_PARAMS'];
      if (webFormRouteParams && webFormRouteParams.startsWith('{') && webFormRouteParams.endsWith('}')) {
        webFormRouteParams = decodeURI(encodeURI(webFormRouteParams).replace(/%0A/g, '\\n').replace(/%09/g, '\\t').replace(/%0D/g, '\\r'));
        result = JSON.parse(webFormRouteParams);
      }
      Object.keys(queryParams).forEach((prop) => {
        if (prop !== 'WEB_FORM_ROUTE_PARAMS') {
          result[prop] = queryParams[prop];
        }
      });
      return result;
    }
    return queryParams;
  }
  private highOrderInvoke(callback) {
    return () => {
      try {
        const queryParams = this.getParams(this.params);
        const tabId = this.getTabId(queryParams);
        if (tabId) {
          const controlEvent = this.runtimeFrameworkService.getMenuSwitchControlEvent();
          if (controlEvent && isObservable(controlEvent)) {
            controlEvent.subscribe((event: any) => {
              if (event) {
                event.next('ok');
              }
            });
          }
        }
      } catch (e) {
        console.warn(e);
      }
      if (callback && typeof callback === 'function') {
        callback();
      }
    };
  }
}
